import React, { Component } from 'react';
import Tile from '../components/tile';
import Video from '../components/video';
class LinoType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playVideo: false,
     
      videoUrl: '',
      images: [
        {
          url:  'Linotype.jpg',
          video: 'linotype',
          subtitles: undefined,
          subtitlesIrish: undefined,
          prevText: "",
          nextText: "Next Printer"
        },
         {
          url:  'Linotype.jpg',
          video: 'harryLinotype',
          subtitles: 'captions_Linotype.vtt',
          subtitlesIrish: 'captions_Irish_Linotype.vtt',
          prevText: "Previous Printer",
          nextText: ""
        },
       
      ],
      mediaIndex: 0
    };
  }
  
  playVideo(index) {
    this.setState({ playVideo: true, mediaIndex: index });

    var elem = document.body;

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) { /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
      document.body.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { /* IE/Edge */
      elem.msRequestFullscreen();
    }
  }

  closeVideo() {
    this.setState({ playVideo: false, mediaIndex: 0 });
  }

  nextVideo() {
   if( this.state.mediaIndex < this.state.images.length -1 )
    this.setState({mediaIndex: this.state.mediaIndex + 1})

    else{
      this.setState({ playVideo: false, mediaIndex: 0 });
    }
  }

  prevVideo() {
    if( this.state.mediaIndex > 0 )
    this.setState({mediaIndex: this.state.mediaIndex - 1})
  }
  render() {
    const mediaIndex = this.state.mediaIndex;
    const text =
    'The Linotype was invented by Ottmar Merganthaler in 1885 and was the first means of mechanized type composition; prior to this all type was handset. It was primarily used in the newspapers.';
    return (
      <div className="shaw">
        {this.state.playVideo ? (
          <Video
            onClose={() => this.closeVideo()}
            onNext={() => this.nextVideo() }
            subtitles={this.state.images[mediaIndex].subtitles}
            playNext={() => this.nextVideo()}
            nextText={this.state.images[mediaIndex].nextText}
            noLast={this.state.mediaIndex === this.state.images.length -1}
            noFirst={this.state.mediaIndex === 0}
            subtitlesIrish={this.state.images[mediaIndex].subtitlesIrish}
            onPrev={() => this.prevVideo()}
            videoUrl={this.state.images[mediaIndex].video}
            imageUrl={this.state.images[mediaIndex].url}
            nextText={this.state.images[mediaIndex].nextText}
            prevText={this.state.images[mediaIndex].prevText}
          />
        ) : (
          <div style={{flex: 1}}>
            <Tile
              bg={'Linotype.jpg'}
              titleImage={'Linotype.png'}
              onPlay={(index) => this.playVideo(index)}
              title={'Vandercook Proofing Press, Printer - Freddie Snowe'}
              subTitle={
                '- Harry Havelin'
              }
              bold={
                'Compositor'
              }
              text={text}
            />
            </div>
        )}
      </div>
    );
  }
}

export default LinoType;



// WEBPACK FOOTER //
// ./src/pages/LinoType.js